import * as $ from "jquery";

export default class CustomerLedgerComponent {
    constructor() {
        this.componentSelector = ".active-user--ledger";
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length === 0) return;

        let customerNo = $(instance.componentSelector).data('customer-no');
        let marketId = $(instance.componentSelector).data('market-id');

        if (!customerNo) return;

        instance.loadLedger(customerNo, marketId, instance);
    }

    loadLedger(customerNo, marketId, instance) {
        axios({
            method: 'post',
            url: "/customer/getcustomerledger",
            data: { customerNo: customerNo, marketId: marketId }
        }).then(function (response) {
            let entries = response.data;
            let total = 0;

            entries.forEach(function (entry) {
                if (entry.RemainingAmount > 0) {
                    total += entry.RemainingAmount;
                }
            });

            $('#ledger-overdue-amount').text(total.toFixed(2));

            instance.formatAmount();

            if (total > 0) {
                $(instance.componentSelector).addClass('has-overdue');
            }

            $(instance.componentSelector).on('click', function () {
                instance.showLedgerPopup(entries, instance);
            });

        }).catch(function (response) {
            console.log(response);
        });
    }

    showLedgerPopup(entries, instance) {
        let overdueEntries = entries.filter(function (e) { return e.RemainingAmount > 0; });

        if (overdueEntries.length === 0) {
            bootbox.alert('Inga förfallna poster.');
            return;
        }

        let html = '<div style="max-height: 400px; overflow-y: auto; overflow-x: auto;">';
        html += '<table class="table table-striped" style="white-space: nowrap;">';
        html += '<thead><tr>';
        html += '<th style="text-align:center">Dok.nr</th>';
        html += '<th style="text-align:center">Typ</th>';
        html += '<th style="text-align:center">Bokföringsdatum</th>';
        html += '<th style="text-align:center">Förfallodatum</th>';
        html += '<th style="text-align:center">Originalbelopp</th>';
        html += '<th style="text-align:center">Återstår</th>';
        html += '<th style="text-align:center">Påminnelsenivå</th>';
        html += '<th style="text-align:center">Tviststatus</th>';
        html += '</tr></thead>';
        html += '<tbody>';

        overdueEntries.forEach(function (entry) {
            html += '<tr>';
            html += '<td style="text-align:center">' + entry.DocumentNo + '</td>';
            html += '<td style="text-align:center">' + entry.DocumentType + '</td>';
            html += '<td style="text-align:center">' + instance.formatDate(entry.PostingDate) + '</td>';
            html += '<td style="text-align:center">' + instance.formatDate(entry.DueDate) + '</td>';
            html += '<td style="text-align:center">' + entry.OriginalAmount.toFixed(2) + '</td>';
            html += '<td style="text-align:center">' + entry.RemainingAmount.toFixed(2) + '</td>';
            html += '<td style="text-align:center">' + entry.LastIssuedReminderLevel + '</td>';
            html += '<td style="text-align:center">' + (entry.DisputeStatus || '-') + '</td>';
            html += '</tr>';
        });

        html += '</tbody></table>';
        html += `<p>Totalt förfallet belopp: ${overdueEntries.reduce(function (sum, e) { return sum + e.RemainingAmount; }, 0).toFixed(2)}</p>`;

        bootbox.dialog({
            title: 'Förfallna poster',
            message: html,
            size: 'large',
            buttons: { close: { label: 'Stäng', className: 'btn-default' } }
        });
    }

    formatDate(dateStr) {
        if (!dateStr) return '-';
        var d = new Date(dateStr);
        var day = ('0' + d.getDate()).slice(-2);
        var month = ('0' + (d.getMonth() + 1)).slice(-2);
        var year = d.getFullYear();
        return year + '-' + month + '-' + day;
    }

    formatAmount() {
        let market = $('body').data('lang').toLowerCase();
        let currency = "SEK";

        if (market == "da-dk") {
            currency = "DKK";
        }

        if (market == "nb-no") {
            currency = "NOK";
        }

        if (market == "fi-fi") {
            currency = "EUR";
        }


        let $amount = $('#ledger-overdue-amount');
        let value = $amount.html().replace(",", ".").replace("kr&nbsp;", "").replace("kr.", "").replace("kr", "").replace("€", "").replaceAll("&nbsp;", "");
        let formatted = new Intl.NumberFormat(market, { style: 'currency', currency: currency }).format(value);

        if (currency == "NOK") {
            formatted = formatted.replace("kr", "");
            formatted += " kr";
        }

        $amount.addClass("formatted");
        $amount.html(formatted);
    }
}